import React from 'react';
import ScNumberControl from '@/components/sc-controls/form-controls/v2/sc-number-control';
import { FieldProps } from '../form-helpers';

export type FormFieldNumberProps = Omit<FieldProps, 'value' | 'onChange'> & {
    value: number | null;
    onChange: (value: number | null) => void;
};

function FormFieldNumber({ label, required, value, onChange, onBlur, error, disabled, inTable }: FormFieldNumberProps) {
    return (
        <ScNumberControl
            label={label}
            required={required}
            value={value ?? undefined}
            onChange={(val: number | string) => onChange(val === '' || val === undefined ? null : Number(val))}
            onBlur={onBlur}
            error={error}
            disabled={disabled}
            maw={inTable ? '100%' : undefined}
        />
    );
}

export default React.memo(FormFieldNumber);
